<template>
  <div class="segments-tab">
    <div class="charts-row">
      <StatBarChart
        class="chart-card"
        title="Комиссия по сегментам"
        :rows="commissionRows"
        :value-formatter="fmtMoney"
        color="#3b82f6"
        :height="chartHeight"
        empty-text="Нет данных"
      />
      <StatBarChart
        class="chart-card"
        title="Рейсов по сегментам"
        :rows="tripsRows"
        :value-formatter="fmtNum"
        color="#12b76a"
        :height="chartHeight"
        empty-text="Нет данных"
      />
      <StatBarChart
        class="chart-card"
        title="Победы: бот / люди"
        :rows="winsRows"
        :value-formatter="fmtNum"
        color="#7a5af8"
        :height="winsHeight"
        empty-text="Нет данных о ставках"
      />
    </div>
    <div class="table-scroll">
      <table class="stat-table" v-if="rows.length">
        <thead>
          <tr>
            <th>Сегмент</th>
            <th class="num">Рейсов</th>
            <th class="num">Ср. маржа</th>
            <th class="num">Ср. рентаб.</th>
            <th class="num">Комиссия</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.segment">
            <td class="seg-cell">
              <span class="seg-dot" :class="segClass(row.segment)"></span>
              {{ row.segment || '—' }}
            </td>
            <td class="num">{{ fmtNum(row.trips) }}</td>
            <td class="num">{{ fmtPct(row.avg_margin_pct) }}</td>
            <td class="num">{{ fmtPct(row.avg_profitability_pct) }}</td>
            <td class="num strong">{{ fmtMoney(row.total_commission) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="!isLoading" class="empty-table">Нет данных по выбранным фильтрам</div>
    </div>
  </div>
</template>

<script>
import StatBarChart from './StatBarChart.vue';
import { fmtMoney, fmtNum, fmtPct } from '../format';

const SEGMENT_COLORS = {
  Гарантия: 'seg-guarantee',
  Спот: 'seg-spot',
  Карусель: 'seg-carousel',
};

export default {
  name: 'SegmentsTab',
  components: { StatBarChart },
  props: {
    rows: { type: Array, default: () => [] },
    kpis: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
  },
  computed: {
    commissionRows() {
      return this.rows
        .filter((row) => row.total_commission != null)
        .map((row) => ({ label: row.segment || '—', value: Number(row.total_commission) }));
    },
    tripsRows() {
      return this.rows.map((row) => ({ label: row.segment || '—', value: Number(row.trips) }));
    },
    winsRows() {
      const kpis = this.kpis || {};
      const rows = [];
      if (kpis.bot_wins != null) rows.push({ label: 'Бот', value: Number(kpis.bot_wins) });
      if (kpis.human_wins != null) rows.push({ label: 'Люди', value: Number(kpis.human_wins) });
      return rows;
    },
    winsHeight() {
      return Math.max(160, this.winsRows.length * 36 + 40);
    },
    chartHeight() {
      const count = Math.max(this.rows.length, 1);
      return Math.max(160, count * 36 + 40);
    },
  },
  methods: {
    fmtMoney,
    fmtNum,
    fmtPct,
    segClass(segment) {
      return SEGMENT_COLORS[segment] || 'seg-other';
    },
  },
};
</script>

<style scoped>
.segments-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.charts-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 16px;
}

.chart-card {
  min-width: 0;
}

.table-scroll {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}

.stat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.stat-table th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  color: #667085;
  font-weight: 600;
  text-align: left;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.stat-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f2f4f7;
  color: #1d2939;
  white-space: nowrap;
}

.stat-table tbody tr:hover {
  background: #f8fafc;
}

.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.strong {
  font-weight: 600;
}

.seg-cell {
  font-weight: 500;
}

.seg-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
}

.seg-guarantee {
  background: #3b82f6;
}

.seg-spot {
  background: #f79009;
}

.seg-carousel {
  background: #7a5af8;
}

.seg-other {
  background: #98a2b3;
}

.empty-table {
  padding: 40px;
  text-align: center;
  color: #98a2b3;
  font-size: 14px;
}
</style>
